import { defineStore } from 'pinia'
import api from '@/plugins/axios'

export const useExplanationStore = defineStore('explanation', {
  state: () => ({
    selectedMessage: null,
    selectedMessageId: null,
    selectedMessageIsUser: null,
    grammar: null,
    vocabulary: null,
    cultural: null,
    translation: null,
    feedback: null,
    loading: false,
    showCreditsModal: false,
    hasError: false,
    errorType: null
  }),
  actions: {
    setSelectedMessage (message, messageId, isUser) {
      console.log('setSelectedMessage', isUser)
      this.selectedMessage = message
      this.selectedMessageId = messageId
      this.selectedMessageIsUser = isUser
    },
    async getMessageInsight (conversationId, messageId, locale) {
      console.log('getMessageInsight', conversationId, messageId)
      this.selectedMessageId = messageId
      this.hasError = false
      this.errorType = null

      this.loading = true
      try {
        const response = await api.post('/analysis/insight', {
          conversation_id: conversationId,
          message_id: messageId,
          explanation_lang: locale
        })
        this.grammar = response.data.grammar
        this.vocabulary = response.data.vocabulary
        this.cultural = response.data.cultural
        this.translation = response.data.translation
      } catch (error) {
        console.error('Error fetching message insights:', error)
        this.hasError = true

        if (error.response && error.response.status === 403) {
          this.errorType = 'credits'
          this.showCreditsModal = true
        } else {
          this.errorType = 'general'
        }
      } finally {
        this.loading = false
      }
    },
    clearSelectedMessage () {
      this.loading = false
      this.selectedMessage = null
      this.selectedMessageId = null
      this.selectedMessageIsUser = null
      this.grammar = null
      this.vocabulary = null
      this.cultural = null
      this.feedback = null
      this.showCreditsModal = false
      this.hasError = false
      this.errorType = null
    }
  }
})
